import { render } from "./pc_login.vue?vue&type=template&id=8b0bda68&scoped=true"
import script from "./pc_login.vue?vue&type=script&lang=js"
export * from "./pc_login.vue?vue&type=script&lang=js"

import "./pc_login.vue?vue&type=style&index=0&id=8b0bda68&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b0bda68"]])

export default __exports__